import apiUrl from "./config.json";

const API_KEY = apiUrl.APIKey;

const requests = {
	fetchGenre: `/genre/movie/list?api_key=${API_KEY}&language=en-US`,
	fetchTrending: `/trending/all/week?api_key=${API_KEY}&num_votes=2000&language=en-US`,
	fetchNetflixOriginals: `/discover/tv?api_key=${API_KEY}&num_votes=2000&with_network=213`,
	fetchTopRated: `/movie/top_rated?api_key=${API_KEY}&num_votes=2000&language=en-US`,
	fetchActionMovies: `/discover/movie?api_key=${API_KEY}&num_votes=2000&with_genres=28`,
	fetchComedyMovies: `/discover/movie?api_key=${API_KEY}&num_votes=2000&with_genres=35`,
	fetchHorrorMovies: `/discover/movie?api_key=${API_KEY}&num_votes=2000&with_genres=27`,
	fetchRomanceMovies: `/discover/movie?api_key=${API_KEY}}&num_votes=2000&with_genres=10749&sort_by=popularity.desc`,
	fetchRecomendattions: `/discover/movie?api_key=${API_KEY}&num_votes=2000&language=en-US&with_genres==27%2C53&sort_by=popularity.desc`,
	fetchMental: `/keyword/41329-mental-illness/movies?api_key=${API_KEY}&num_votes=2000&language=en-US&sort=user_rating`,
	fetchMultiplePersonality: `/keyword/169411-multiple-personality/movies?api_key=${API_KEY}&num_votes=2000&language=en-US&sort=user_rating`,
	fetchTraumaticChildhood: `/keyword/208370-traumatic-childhood/movies?api_key=${API_KEY}&num_votes=2000&language=en-US&sort=user_rating`,
};

export default requests;
